module.exports = __webpack_public_path__ + "static/media/pet_logo.451439c4.svg";